import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationApiService {

    private readonly apiUrl = '/apiParams/v1/translations';

    constructor(private readonly http: HttpClient) {
    }

    getTranslations(locale: string, ifNoneMatch?: string): Observable<HttpResponse<any>> {
        const params = new HttpParams()
            .set('application', 'epp-client')
            .set('locale', locale);

        const headers: { [key: string]: string } = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = `"${ifNoneMatch}"`;
        }

        return this.http.get<any>(this.apiUrl, {
            params,
            headers,
            observe: 'response'
        });
    }
}

